import { AnalysisConfig, Camera, CameraMemo, CameraWithAnalysisConfig } from "~/_legacy/types/analysis";
import { getSortedCameras } from "./sort";

export const combineCamerasWithAnalysisConfigs = (
  cameras: Camera[],
  analysisConfigs: AnalysisConfig[]
): CameraWithAnalysisConfig[] => {
  const combined = cameras.map((camera) => {
    const analysisConfig = analysisConfigs.find(({ cameraId }) => cameraId === camera.id) ?? {
      countingLines: [],
      intervalZones: [],
      memos: [],
    };
    return { ...camera, ...analysisConfig };
  });

  return getSortedCameras(combined);
};

export const combineCamerasWithAnalysisConfigsAndCameraMemos = (
  cameras: Camera[],
  analysisConfigs: AnalysisConfig[],
  cameraMemos: CameraMemo[]
) => {
  const combined = combineCamerasWithAnalysisConfigs(cameras, analysisConfigs);

  const combinedWithCameraMemos = combined.map((camera) => {
    const matchedCameraMemos = cameraMemos.filter(({ cameraId }) => cameraId === camera.id);
    return { ...camera, memos: matchedCameraMemos };
  });

  return getSortedCameras(combinedWithCameraMemos);
};
